"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsLogsByThingPKTable = void 0;
var _react = _interopRequireWildcard(require("react"));
var _DmsTable = require("../DmsTable/DmsTable");
var _DmsTableButton = require("../DmsTableButton/DmsTableButton");
var _Visibility = _interopRequireDefault(require("@mui/icons-material/Visibility"));
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _moment = _interopRequireDefault(require("moment"));
var _Permissions = require("../../constants/Permissions");
var _Log = require("../../constants/Log");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const DmsLogsByThingPKTable = _ref => {
  let {
    thing_pk,
    onDetailsClick
  } = _ref;
  const table = (0, _react.useRef)(null);
  const header = [{
    label: _reactIntlUniversal.default.get("Module").d("Module"),
    column_name: "module",
    filter: true,
    permissions: [_Permissions.Permissions.POLLUX_PERMISSION]
  }, {
    label: _reactIntlUniversal.default.get("Level").d("Level"),
    column_name: "level",
    map: Object.fromEntries(Object.entries(_Log.LogLevel).map(_ref2 => {
      let [key, value] = _ref2;
      return [value, key];
    })),
    control: 'select',
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Type").d("Type"),
    column_name: "type",
    map: Object.fromEntries(Object.entries(_Log.LogType).map(_ref3 => {
      let [key, value] = _ref3;
      return [value, key];
    })),
    control: 'select',
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("User").d("User"),
    column_name: "created_by_id",
    control: 'select',
    url: "/user/all",
    properties: {
      column_name: "created_by_id",
      text_template: '{user_name}',
      label: "user_name",
      value: "pk",
      filter: {
        field: 'created_by_id',
        value: 'pk'
      }
    },
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("IPv4").d("IPv4"),
    column_name: "ipv4",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Date").d("Date"),
    column_name: "created_on",
    function: date => (0, _moment.default)(date).format("DD/MM/YYYY HH:mm:ss"),
    control: 'datetime',
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Description").d("Description"),
    column_name: "description",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Details").d("Details"),
    permissions: [_Permissions.Permissions.CAN_VIEW_LOGS_GENERAL_DETAILS],
    width: "4.17vw",
    sortable: false,
    element: /*#__PURE__*/_react.default.createElement(_DmsTableButton.DmsTableButton, {
      table: table,
      icon: /*#__PURE__*/_react.default.createElement(_Visibility.default, null),
      onClick: onDetailsClick
    })
  }];
  return /*#__PURE__*/_react.default.createElement(_DmsTable.DmsTable, {
    header: header,
    managed: true,
    needs_authentication: true,
    ref: table,
    export_table: false,
    url: "/logs_by_thing/".concat(thing_pk),
    responsive: true
  });
};
exports.DmsLogsByThingPKTable = DmsLogsByThingPKTable;